import Home from './pages/Home';
import './App.css';
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  return <Home />;
}

export default App;
